<mat-nav-list class="menu" role="navigation" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
    <mat-list-item [disabled]="organizationsService.getCurrentOrganization() === null" routerLink="./instance" routerLinkActive="active-list-item">
        <a routerLink="/instance" style="display: none"></a>
        <mat-icon matListItemIcon>settings</mat-icon>
        @if (isExpanded || isShowing) {
        <span matListItemTitle>{{ 'NavMenu.Instance' | translate }}</span>
        }
    </mat-list-item>

    @if (instanceService.isInitialized) {
    <mat-divider class="divider"></mat-divider>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./dashboard" routerLinkActive="active-list-item">
        <a routerLink="/dashboard" style="display: none"></a>
        <mat-icon matListItemIcon>dashboard</mat-icon>
        @if (isExpanded || isShowing) {
        <span matListItemTitle>{{ 'NavMenu.Dashboard' | translate }}</span>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-divider class="divider"></mat-divider>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./sdas" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une SDA -->
        <a routerLink="/sda" style="display: none"></a>
        <mat-icon matListItemIcon>phone</mat-icon>
        @if (isExpanded || isShowing) {
        <span matListItemTitle>{{ 'NavMenu.SDA' | translate }}</span>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./sites" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'un site -->
        <a routerLink="/site" style="display: none"></a>
        <mat-icon matListItemIcon>factory</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Sites' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./services" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'un service -->
        <a routerLink="/service" style="display: none"></a>
        <mat-icon matListItemIcon>apartment</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Services' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./devices" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'un périphérique -->
        <a routerLink="/device" style="display: none"></a>
        <mat-icon matListItemIcon>devices_other</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Devices' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./calendars" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'un calendrier -->
        <a routerLink="/calendar" style="display: none"></a>
        <mat-icon matListItemIcon>edit_calendar</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Calendars' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./extensions" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une extension -->
        <a routerLink="/extension" style="display: none"></a>
        <mat-icon matListItemIcon>extension</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Extensions' | translate }}</div>
        }
        <!-- <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon> -->
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./globalrules" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une règle globale -->
        <a routerLink="/globalrule" style="display: none"></a>
        <mat-icon matListItemIcon>admin_panel_settings</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.GlobalRules' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./restrictions" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une restriction -->
        <a routerLink="/restriction" style="display: none"></a>
        <mat-icon matListItemIcon>phone_locked</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Restrictions' | translate }}</div>
        }
    </mat-list-item>
    }@if (instanceService.isInitialized) {
    <mat-list-item routerLink="./functions" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une restriction -->
        <a routerLink="/functions" style="display: none"></a>
        <mat-icon matListItemIcon>phone_locked</mat-icon>
        @if (isExpanded || isShowing) {
        <div matListItemTitle>{{ 'NavMenu.Functions' | translate }}</div>
        }
    </mat-list-item>
    } @if (instanceService.isInitialized) {
    <mat-divider class="divider"></mat-divider>
    } @if (instanceService.isInitialized) {
    <mat-list-item routerLink="./cdrs" routerLinkActive="active-list-item">
        <!-- Permet de rendre le menu sélectionné lors de l'édition d'une CDR -->
        <a routerLink="/cdr" style="display: none"></a>
        <mat-icon matListItemIcon>manage_history</mat-icon>
        @if (isExpanded || isShowing) {
        <span matListItemTitle>{{ 'NavMenu.CDR' | translate }}</span>
        }
    </mat-list-item>
    }
</mat-nav-list>
